import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCalendarEditComponent } from "./med-icon-calendar-edit.component";

@NgModule({
  declarations: [
    MedIconCalendarEditComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCalendarEditComponent,
  ],
})
export class MedIconCalendarEditModule { }
